// Add your JS customizations here

(function () {var a = {};var f = /iPhone/i, h = /iPod/i, i = /iPad/i, r = /\biOS-universal(?:.+)Mac\b/i, g = /\bAndroid(?:.+)Mobile\b/i,j = /Android/i, c = /(?:SD4930UR|\bSilk(?:.+)Mobile\b)/i, d = /Silk/i, b = /Windows Phone/i,k = /\bWindows(?:.+)ARM\b/i, m = /BlackBerry/i, n = /BB10/i, o = /Opera Mini/i,p = /\b(CriOS|Chrome)(?:.+)Mobile/i, q = /Mobile(?:.+)Firefox\b/i;	function s(l) {return function ($) {return $.test(l)}}function e(l) {var $ = (l = l || ("undefined" != typeof navigator ? navigator.userAgent : "")).split("[FBAN");void 0 !== $[1] && (l = $[0]), void 0 !== ($ = l.split("Twitter"))[1] && (l = $[0]);var a = s(l), e = {apple: {phone: a(f) && !a(b),ipod: a(h),tablet: !a(f) && a(i) && !a(b),universal: a(r),device: (a(f) || a(h) || a(i)) && !a(b)},amazon: {phone: a(c), tablet: !a(c) && a(d), device: a(c) || a(d)},android: {phone: !a(b) && a(c) || !a(b) && a(g),tablet: !a(b) && !a(c) && !a(g) && (a(d) || a(j)),device: !a(b) && (a(c) || a(d) || a(g) || a(j)) || a(/\bokhttp\b/i)},windows: {phone: a(b), tablet: a(k), device: a(b) || a(k)},other: {blackberry: a(m),blackberry10: a(n),opera: a(o),firefox: a(q),chrome: a(p),device: a(m) || a(n) || a(o) || a(q) || a(p)},any: !1,phone: !1,tablet: !1}; return e.any = e.apple.universal || e.apple.device || e.android.device || e.windows.device || e.other.device, e.phone = e.apple.phone || e.android.phone || e.windows.phone, e.tablet = e.apple.tablet || e.android.tablet || e.windows.tablet, e;}e  = e();window.isMobile = e;})();

(function () { if ( jQuery ) {

	jQuery(document).ready( function(){
		jQuery('#header-search').on('click', function(){ if( jQuery('#header-search').hasClass('input-hidden') ) { jQuery('#s').focus(); jQuery('#header-search').removeClass('input-hidden'); var check_maybe_hide_input = setInterval( function() { if ( ! jQuery( '#header-search' ).is(':focus-within') ) { clearInterval(check_maybe_hide_input); jQuery('#header-search').addClass('input-hidden'); } }, 200 ); }}); jQuery( '#header-search' ).on( 'submit', '#searchform', function(e){ if ( jQuery( this ).children('#s').val() === '') { e.preventDefault(); } } );
		jQuery('#menu-search').on('click', function(){ if( jQuery('#menu-search').hasClass('input-hidden') ) { jQuery('#menu-s').focus(); jQuery('#menu-search').removeClass('input-hidden'); var check_maybe_hide_input = setInterval( function() { if ( ! jQuery( '#menu-search' ).is(':focus-within') ) { clearInterval(check_maybe_hide_input); jQuery('#menu-search').addClass('input-hidden'); } }, 200 ); }}); jQuery( '#menu-search' ).on( 'submit', '#menu-searchform', function(e){ if ( jQuery( this ).children('#menu-s').val() === '') { e.preventDefault(); } } );
		jQuery('#scrolltop-button').on('click', function(){ jQuery('html,body').animate({'scrollTop': 0}, 200 ); setTimeout( function(){ jQuery('body').removeClass('scroll-up')}, 300);});

		let pumOpenInterval;

		if( window.location.hash && (( window.location.hash === '#nous-contacter' )||( window.location.hash === '#contact-us' )) ) {

			PUM.close(60947);
			PUM.preventOpen(60947);

			PUM.close(60949);
			PUM.preventOpen(60949);
		}

		if( window.location.hash && ( window.location.hash === '#contact-us' ) ) {

			setTimeout( function() {
				PUM.open(21051);
			}, 250 );
		}

		if( window.location.hash && ( window.location.hash === '#nous-contacter' ) ) {

			setTimeout( function() {
				PUM.open(16166);
			}, 250 );
		}
	});

	(function ($){

		let oldScrollPosition = 0;

		$(document).on('scroll', function(e) {

			let newScrollPosition = jQuery(window).scrollTop();

			if ( newScrollPosition < oldScrollPosition ) {

				jQuery('body').addClass('scroll-up')
			} else {

				jQuery('body').removeClass('scroll-up')
			}

			oldScrollPosition = newScrollPosition;

			if( newScrollPosition >= 50 ) {

				$(document.body).addClass('header--sticked');
			} else {

				$(document.body).removeClass('header--sticked');
				$(document.body).removeClass('scroll-up');
			}
		})

		let Megamenu = {
			$megamenu_el : null,

			init: function() {

				Megamenu.$megamenu_el = $('[data-trigger-megamenu]');

				if ( Megamenu.$megamenu_el.length === 0 ) {

					return;
				}

				Megamenu.$megamenu_el.each( function() {

					const $this = $(this);

					let $trigger  = $this.parent(),
						$selector = $trigger.find( $this.data('trigger-megamenu') );

					if ( $selector.length ) {

						$trigger.data( 'wrapper', $selector.first() );

						if ( $trigger.closest( '#main-mobile-nav' ).length ) {

							$this.on( 'click', Megamenu.toggleMegamenu );

							$trigger.on( 'click', '.megamenu-column > .h3', Megamenu.toggleMegamenuColumn );
						} else {

							$this.on( 'click', Megamenu.toggleMegamenu );
							$trigger.on( 'mouseenter', Megamenu.showMegamenu );
							$trigger.on( 'mouseleave', Megamenu.hideMegamenu );
						}
					}
				});

				$( document ).on( 'keyup', Megamenu.hideMegamenuKey );
			},

			toggleMegamenu: function( e ) {

				e.preventDefault();

				const $this = $(this);
				const $megamenuWrapper = $this.parent();

				if ( $megamenuWrapper.hasClass( 'shown' ) ) {

					$megamenuWrapper.removeClass( 'shown' );

					Megamenu.controlMegamenu( $megamenuWrapper, 'hide' );
				} else {

					$megamenuWrapper.addClass( 'shown' );

					$megamenuWrapper.data( 'wrapper' ).find( '.megamenu-column' ).addClass( 'closed' );

					Megamenu.controlMegamenu( $megamenuWrapper, 'show' );
				}
			},

			showMegamenu: function() {

				// console.log( 'Menu Open');

				const $this = $( this );

				$this.data( 'state', 'shown' );

				$this.addClass( 'shown' );

				Megamenu.controlMegamenu( $this, 'show' );
			},

			hideMegamenu: function() {

				// console.log( 'Menu Close');

				const $this = $( this );

				$this.data( 'state', 'hidden' );

				$this.removeClass( 'shown' );

				Megamenu.controlMegamenu( $( this ), 'hide' );
			},

			hideMegamenuKey: function( e ) {

				if (e.key !== "Escape") { // escape key maps to keycode `27`
					return;
				}
				// console.log( 'Menu Close');

				Megamenu.$megamenu_el.each( function() {

					const $this = $( this ).parent();

					$this.data( 'state', 'hidden' );

					$this.removeClass( 'shown' );

					Megamenu.controlMegamenu( $this, 'hide' );
				});
			},

			controlMegamenu: function( $el, action ) {

				if ( $el.data( 'suspend' ) === true ) {

					return;
				}

				let $wrapper = $el.data( 'wrapper' );

				if ( 'undefined' === typeof $wrapper ) {

					return;
				}

				if ( action === 'show' ) {

					$el.data( 'suspend', true );
					$wrapper.slideDown( 600, function() { $el.data( 'suspend', false ); } );
				}
				if ( action === 'hide' ) {

					$el.data( 'suspend', true );
					$wrapper.slideUp( 600, function() { $el.data( 'suspend', false ); } );
				}
			},
			toggleMegamenuColumn: function(e) {

				e.stopImmediatePropagation();

				const $this = $(this);

				if ( $this.is('.h3') ) {

					$this.parent().toggleClass( 'closed' );

					return false;
				}

				return true;
			}
		};

		window.triggerMobileMenuContentsChange = function (action) {

			if( window.isMobile.any ) {

				return;
			}

			$('#main-menu-desktop').html('');
			$('#main-menu-mobile').html('');

			$( (action === 'open') ? '#main-menu-mobile' : '#main-menu-desktop' ).html( window.puifMenu );

			MegamenuInit();
		}

		$(document).ready( function(){

			window.puifMenu = jQuery('#main-menu-desktop').html();

			if( window.isMobile.any ) {

				$( '#main-menu-desktop' ).html('');

				$( '#main-menu-mobile' ).html( window.puifMenu );

				jQuery('#main-mobile-nav .navbar-toggler').attr('style', 'display:inline-block!important');

				jQuery('#header-search').attr('style', 'display:none!important');
			}

			Megamenu.init();

			window.MegamenuInit = Megamenu.init;


			// “Add to Cart” CTA on PDP page
			$(document).on('click', '.puif-add-to-cart-button.add_to_cart_button', function (e) {
				dataLayer.push({
					'event': 'trackEvent',
					'eventCategory': 'checkout_flow',
					'eventAction': 'click_button',
					'eventLabel': 'add_to_cart'
				});
			});

			// “Be notified” CTA on PDP page
			$(document).on('click', '.stock-notification-modal-toggle', function (e) {
				dataLayer.push({
					'event': 'trackEvent',
					'eventCategory': 'pdp_action',
					'eventAction': 'click_button',
					'eventLabel': 'be_notified'
				});
			});

			// “Be recontacted” CTA on PDP page
			$(document).on('click', '.get-contacted-modal-toggle', function (e) {
				dataLayer.push({
					'event': 'trackEvent',
					'eventCategory': 'pdp_action',
					'eventAction': 'click_button',
					'eventLabel': 'be_recontacted'
				});
			});


			// “View cart” CTA in PDP pop-up
			$(document).on('click', '.view-cart-button', function (e) {
				dataLayer.push({
					'event': 'trackEvent',
					'eventCategory': 'checkout_flow',
					'eventAction': 'click_button',
					'eventLabel': 'view_cart'
				});
			});

			// “Continue” CTA on cart page
			$(document).on('click', '#proceed-to-checkout-button', function (e) {
				dataLayer.push({
					'event': 'trackEvent',
					'eventCategory': 'checkout_flow',
					'eventAction': 'click_button',
					'eventLabel': 'continue_to_checkout'
				});
			});

			// “Order and pay” CTA on checkout page
			$(document).on('click', '#place_order', function (e) {
				dataLayer.push({
					'event': 'trackEvent',
					'eventCategory': 'checkout_flow',
					'eventAction': 'click_button',
					'eventLabel': 'order_and_pay'
				});
			});

			$(document).ready( function (e) {
				if (jQuery('h1.woocommerce-thankyou-order-received').length > 0) {
					// Order confirmation page loading event
					dataLayer.push({
						'event': 'trackEvent',
						'eventCategory': 'checkout_flow',
						'eventAction': 'page_load',
						'eventLabel': 'order_confirmation'
					});
				}
			});

			// “Download the collection sheet” CTA on multi-category collection
			// “Download the collection sheet” CTA on mono-category collection
			$(document).on('click', '.collection-catalog-file-link', function (e) {
				dataLayer.push({
					'event': 'trackEvent',
					'eventCategory': 'catalog_download',
					'eventAction': 'click_button',
					'eventLabel': ( jQuery( this ).data( 'collection' ) ? jQuery( this ).data( 'collection' ) : 'unknown' )
				});
			});
		} );

		$(document).on('click', '.woocommerce-notice-close', function(e) {

			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();


			if ( jQuery(this).parent().hasClass( 'added-to-cart-ajax-message' ) ) {

				$(this).parent().siblings( '.puif-add-to-cart-button' ).removeClass( 'added' );
			} else {

				$(this).parent().fadeOut( function() { $(this).remove(); } );
			}
		} );

		$( document.body ).on( 'click', '.wpcf7-form-control[type="submit"], .puif-add-to-cart-button.ajax_add_to_cart, #single-product-get-contacted, #single-product-notifyme', function(){
			$.blockUI({
				message: null,
				overlayCSS: {
					background: 'rgba(255,255,255,0.6)',
					'z-index': 2000000000,
					opacity: 1,
				}})
		});

		$( document.body ).on( 'wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7submit wc_cart_button_updated', function(){
			$.unblockUI();
		});

	})(jQuery);
}})();


